import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-stakeholders-itams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-stakeholders-itams.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { CreateApplicationStakeholdersItamsConstants } from "./create-application-stakeholders-itams.constants";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { RecipientListService } from "../../../../../shared/components/recipient-list/shared/recipient-list.service";
import { AppControllerService } from "src/app/app-controller.service";
import { SimulationUtils } from "src/app/shared/utils/simulation-utils";
let CreateApplicationStakeholdersItamsComponent = class CreateApplicationStakeholdersItamsComponent extends CreateApplicationViewBaseComponent {
    createApplicationService;
    aflaModuleStrategyService;
    appController;
    changeDetectorRef;
    recipientListService;
    tradersForm;
    disableTraderRecipientFilter = true;
    traderConfigurableLabel = "Trader";
    traderDisableAddButton = false;
    traderRecipientGroups = [];
    traderDisableEditButton = false;
    showRecipientListButtons = true;
    traderDisableDelete = false;
    traderLabel = CreateApplicationStakeholdersItamsConstants.TRADER_LABEL;
    traderFormControlName = CreateApplicationStakeholdersItamsConstants.TRADER_FORM_ARRAY_NAME;
    removeTradersRecipientListButtonsSubjectSubscription;
    constructor(createApplicationService, aflaModuleStrategyService, appController, changeDetectorRef, recipientListService) {
        super(createApplicationService, aflaModuleStrategyService);
        this.createApplicationService = createApplicationService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.appController = appController;
        this.changeDetectorRef = changeDetectorRef;
        this.recipientListService = recipientListService;
    }
    ngOnInit() {
        this.initForm();
        this.getMetadata();
        this.subscribeToTradersRemoveRecipientListButtons();
    }
    loadMetadata(stepMeta) {
        if (this.appController.moduleSimulateMode) {
            this.traderRecipientGroups = this.recipientListService.checkStepMetaRecipientGroups(SimulationUtils.simulateRecipientFilterGroupObjects);
        }
        else {
            this.traderRecipientGroups = stepMeta.traderGroup;
            if (this.traderRecipientGroups[0].hasOwnProperty("requiredFields") && this.traderRecipientGroups[0].requiredFields !== null) {
                this.traderRecipientGroups = this.recipientListService.checkStepMetaRecipientGroups(this.traderRecipientGroups);
            }
        }
    }
    getTradersControl() {
        return this.tradersForm.get("traders");
    }
    initForm() {
        this.tradersForm = this.aflaModuleStrategyService.form.get(CreateApplicationStakeholdersItamsConstants.TRADERS_FORM_GROUP_NAME);
    }
    subscribeToTradersRemoveRecipientListButtons() {
        this.removeTradersRecipientListButtonsSubjectSubscription = this.createApplicationService.$removeTradersRecipientListButtonsSubject.subscribe({
            next: (removeTradersRecipientListButtons) => {
                if (removeTradersRecipientListButtons) {
                    this.showRecipientListButtons = false;
                }
                else {
                    this.showRecipientListButtons = true;
                }
                this.changeDetectorRef.detectChanges();
            }
        });
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: RecipientListService }
    ];
};
CreateApplicationStakeholdersItamsComponent = __decorate([
    Component({
        selector: "app-create-application-stakeholders-itams",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationStakeholdersItamsComponent);
export { CreateApplicationStakeholdersItamsComponent };
